// extracted by mini-css-extract-plugin
export var createdDate = "_j2-1";
export var divider = "_j2-2";
export var headerDivider = "_j2-3";
export var messagesCard = "_j2-0";
export var messagesContainer = "_j2-6";
export var messagesContainerWrapper = "_j2-4";
export var showLeftPanelButton = "_j2-8";
export var topButtons = "_j2-7";
export var withPadding = "_j2-5";